import { initializeApp } from 'firebase/app'

const { VITE_TARGET_ENV, VITE_FIREBASE_API_KEY } = import.meta.env

const FIREBASE_CONFIG_BY_TARGET = {
  staging: {
    authDomain: 'docu-tools-notifications.firebaseapp.com',
    databaseURL: 'https://docu-tools-notifications.firebaseio.com',
    projectId: 'docu-tools-notifications',
    storageBucket: 'docu-tools-notifications.firebasestorage.app',
    messagingSenderId: '962934613212',
    appId: '1:962934613212:web:993adbd871960e85e2c019',
    measurementId: 'G-20S8L9999N'
  },
  production: {
    authDomain: 'docu-tools-notifications.firebaseapp.com',
    databaseURL: 'https://docu-tools-notifications.firebaseio.com',
    projectId: 'docu-tools-notifications',
    storageBucket: 'docu-tools-notifications.firebasestorage.app',
    messagingSenderId: '962934613212',
    appId: '1:962934613212:web:679e80439596e57de2c019',
    measurementId: 'G-0TXZDM8BK3'
  }
}

export const getFirebaseConfig = () => {
  if (!VITE_FIREBASE_API_KEY) {
    return null
  }

  const selectedConfig =
    VITE_TARGET_ENV === 'production'
      ? FIREBASE_CONFIG_BY_TARGET.production
      : FIREBASE_CONFIG_BY_TARGET.staging

  return {
    apiKey: VITE_FIREBASE_API_KEY,
    ...selectedConfig
  }
}

export const initializeFirebaseApp = () => {
  const firebaseConfig = getFirebaseConfig()

  if (!firebaseConfig) {
    console.warn(
      'Firebase initialization skipped: missing VITE_FIREBASE_API_KEY'
    )
    return null
  }

  return initializeApp(firebaseConfig)
}

export default initializeFirebaseApp
